import React from 'react';
import PropTypes from 'prop-types';
import MediaQueries from 'react-responsive';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import Image from 'marketing-website/components/modules/Image';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Diamonds from 'marketing-website/components/commons/Diamonds';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';
import assets from 'marketing-website/configs/pages/features/collaboration/assets';

export default function TeamsBlock({ color }) {
  return (
    <PageWrap size="l">
      <Spacing size="xl" type="padding" position="topBottom">
        <Grid columns={12} alignItems="center">
          <GridItem columnSpan={12} columnSpanM={5}>
            <MediaQueries minWidth={770}>
              <HeadingBlock
                justifyContent="center"
                justifyM="start"
                maxWidth={430}
                title="All your teams in one place"
                copy={
                  <span>
                    Make it easy to pull in relevant teams onto individual
                    projects with our teams feature, simply group users into
                    teams of your choice. <br /> <br />
                    This means it's effortless to identify and include the right
                    people, when you need to, improving online design
                    collaboration.
                  </span>
                }
              />
            </MediaQueries>
          </GridItem>
          <GridItem columnSpan={12} columnSpanM={7}>
            <MediaMultipleImages
              fallbackImageAlt="See what everyone is working on"
              fallbackImageSrc={assets.teamsFallback.src}
              fallbackImageMaxWidth={829}
            >
              <Shape
                type="rectangle"
                color="lightOrange"
                width={425}
                height={314}
              />
              <ParallaxWrapper speed={1}>
                <Pattern
                  color={color}
                  left="35%"
                  bottom="35%"
                  top="auto"
                  type="shortRectangle"
                />
                <Diamonds left="60%" top="50%" color="orange--l" />
              </ParallaxWrapper>
              <ParallaxWrapper speed={1.7}>
                <Image
                  {...assets.directoryTeams}
                  borderRadius="m"
                  left="5%"
                  maxWidth={650}
                  position="absolute"
                  top="36%"
                />
                <ParallaxWrapper>
                  <Image
                    {...assets.marketingTeam}
                    borderRadius="m"
                    left="25%"
                    maxWidth={440}
                    position="absolute"
                    top="26%"
                  />
                </ParallaxWrapper>
              </ParallaxWrapper>
            </MediaMultipleImages>
            <MediaQueries maxWidth={769}>
              <HeadingBlock
                justifyContent="center"
                justifyM="start"
                maxWidth={430}
                title="Work faster, better and together with every team"
                copy="Marvel helps every team and contribute to ideas and design, no matter what department."
              />
            </MediaQueries>
          </GridItem>
        </Grid>
      </Spacing>
    </PageWrap>
  );
}

TeamsBlock.propTypes = {
  color: PropTypes.string,
};

TeamsBlock.defaultProps = {
  color: null,
};



// WEBPACK FOOTER //
// ./src/pages/features/collaboration/TeamsBlock.js